export const ChartSkeleton = () => {
  return (
    <div className='animate-pulse pt-4 h-full w-full'>
      <div className='h-8 w-32 bg-gray-200 rounded mb-4' /> {/* Title */}
      <div className='h-16 w-48 bg-gray-200 rounded mb-4' /> {/* Percentage */}
      <div className='h-64 w-full bg-gray-200 rounded' /> {/* Graph area */}
    </div>
  )
}
